module.exports = __webpack_public_path__ + "media/images/wowu_ogp-c25d54191b0d427a55690c3d0c6a51d1.png";